export default __webpack_public_path__ + "static/media/free.a0054b06.svg";